export default "__VITE_ASSET__CgkhYF$K__"